module.exports = "data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAADIAAAAyBAMAAADsEZWCAAAABGdBTUEAALGPC/xhBQAAAAFzUkdCAK7OHOkAAAAeUExURUdwTF1dXV1dXV1dXV1dXV1dXV1dXV1dXV1dXV1dXUt0dhYAAAAJdFJOUwCh4V0iwno3ELPXzQYAAAAJcEhZcwAAAEgAAABIAEbJaz4AAADwSURBVDjL3ZS/DoIwEMY7mIgrRHfcGP0Tg5uJg08ASUcHQ9ycmJs4uCoJJve29sq19Io+gNxAevcjx9frR4UYX1yTA8snqzetAJrFzatnAI7oIDY9Z5hZ0pqszMXjYt6SjjxNB4ACH7rzrCfUHeuohhEhop3s6gOi2Ul1C58U3nYKRiDdUnKMgRPomK5DQFBauolRXEBIdpMoERLc0tKIHhIboyA/Jyr11HKaaMtI5E1UBWfaT3R42naiPnnl3L17z6NOGnfvGo2WVp57reOjWiJrK0XuLXv/izo2jNzLfyLjGrAu5XGff6+bz6u/vz8+RtSY8yCyxd4AAAAASUVORK5CYII="


//////////////////
// WEBPACK FOOTER
// ./src/images/TabBar/major.png
// module id = 778
// module chunks = 0